import React from 'react';
import { CiMobile3 } from 'react-icons/ci';
import { FaApplePay, FaHandsHelping } from 'react-icons/fa';
import { GrDocumentImage } from 'react-icons/gr';
import { IoIosPeople } from 'react-icons/io';
import { TbWorldWww } from 'react-icons/tb';

export interface ArticleMetadata {
  title: string;
  description: string;
  Icon: React.ComponentType<{ className?: string }>;
  gradient: string;
  accent: string;
}

export const ARTICLE_METADATA: Record<string, ArticleMetadata> = {
  'customised-club-website': {
    title: 'Customised Club Website',
    description: "Build a branded website tailored to your club's identity and needs.",
    Icon: TbWorldWww,
    gradient: 'from-violet-500 to-fuchsia-500',
    accent: 'bg-violet-500',
  },
  'content-management': {
    title: 'Content Management',
    description: 'Easily update pages, news, and media with intuitive editing tools.',
    Icon: GrDocumentImage,
    gradient: 'from-rose-500 to-orange-400',
    accent: 'bg-rose-500',
  },
  'club-mobile-app': {
    title: 'Club Mobile App',
    description: 'Keep members connected with a dedicated iOS and Android app.',
    Icon: CiMobile3,
    gradient: 'from-emerald-500 to-teal-400',
    accent: 'bg-emerald-500',
  },
  'membership-management': {
    title: 'Membership Management',
    description: 'Handle sign-ups, renewals, and member records effortlessly.',
    Icon: IoIosPeople,
    gradient: 'from-blue-500 to-cyan-400',
    accent: 'bg-blue-500',
  },
  'seamless-payments-refunds': {
    title: 'Seamless Payments & Refunds',
    description: 'Process payments and refunds with integrated Stripe support.',
    Icon: FaApplePay,
    gradient: 'from-slate-600 to-gray-800',
    accent: 'bg-slate-600',
  },
  'hands-on-support': {
    title: 'Hands-On Support',
    description: 'Get direct help from our team whenever you need it.',
    Icon: FaHandsHelping,
    gradient: 'from-yellow-500 to-amber-400',
    accent: 'bg-yellow-500',
  },
};

export const ARTICLE_SLUGS = Object.keys(ARTICLE_METADATA);
